<div class="flex items-center justify-end flex-1 gap-4">
    @if (isEditModeActive()) {
        <div class="flex items-center gap-4">
            <button
                class="table-toolbar-icon-btn delete"
                type="button"
                [disabled]="!canDelete()"
                (click)="deleteEntities.emit()">
                <fa-icon
                    size="lg"
                    [icon]="['fas', 'trash']"
                    [matTooltip]="deleteTooltip()" />
            </button>

            <button
                class="table-toolbar-icon-btn action-button"
                type="button"
                [disabled]="isEditionInProgress() || !canUndoEdit()"
                [matTooltip]="undoTooltip() | transloco"
                (click)="undoEdit.emit()">
                <fa-icon
                    size="lg"
                    [icon]="['fas', 'rotate-left']" />
            </button>

            <button
                class="table-toolbar-icon-btn action-button"
                type="button"
                [disabled]="isEditionInProgress() || !canRedoEdit()"
                [matTooltip]="redoTooltip() | transloco"
                (click)="redoEdit.emit()">
                <fa-icon
                    size="lg"
                    [icon]="['fas', 'rotate-right']" />
            </button>

            <button
                class="table-toolbar-icon-btn action-button"
                type="button"
                [disabled]="!canValidate()"
                (click)="validateEntities.emit()">
                <fa-icon
                    size="lg"
                    [icon]="['fas', 'check']" />
            </button>

            <div class="flex items-center gap-4 pl-2">
                <span class="text-sm font-normal text-custom-extra-dark-grey">
                    {{ 'tableEdition' | transloco }}
                </span>

                <div [matTooltip]="tableEditToggleTooltip() | transloco">
                    <app-toggle
                        [checked]="isTableEditMode()"
                        [disabled]="!canUseTableEditToggle() || !isEditable()"
                        (toggled)="switchToggledMode.emit($event)" />
                </div>
            </div>
        </div>
    }

    <div class="flex flex-none pl-2">
        <app-button
            [disabled]="!canUseGlobalEditButton()"
            [icon]="['fas', 'pen']"
            [label]="isEditModeActive() ? '' : ('edit' | transloco)"
            [tooltip]="editModeTooltip() ? (editModeTooltip() | transloco) : undefined"
            [type]="isEditModeActive() ? ButtonType.TERTIARY : ButtonType.SECONDARY"
            (onClick)="toggleEditMode.emit()" />
    </div>
</div>
